export default class SessionService {

    // Pega dos dados do localStorage
    static getData() {
        const data = localStorage.getItem('data');

        try {
            const parsedData = JSON.parse(data);
            return parsedData;
        } catch (e) {
            return null;
        }
    }

    // Pega apenas o token
    static getToken() {
        const data = this.getData();
        if (data) { return data.token; }
        return null;
    }

    // Pega os dados do user logado
    static getUser() {
        const data = this.getData();
        if (data) { return data.user; }
        return [];
    }

    // Pega os dados do owner logado
    static getOwner() {
        const data = this.getData();
        if (data) { return data.owner; }
        return [];
    }


    static setUser(user) {
        const data = this.getData();
        if (data) {
            data.user = user;
            localStorage.setItem('data', JSON.stringify(data));
        }
    }

    static isLoggedIn() {
        return this.getToken() !== null;
    }

    static logout() {
        localStorage.removeItem('data');
    }



    /**
     * Stores user chats.
     * @param {object[]} chats Chats to be stored.
     */
    static setChatsData(chats, actionsState) {
        const data = this.getData();
        if (data) {
            data.chats = chats;
            data.chatActionsState = actionsState;
            localStorage.setItem('data', JSON.stringify(data));
        }
    }

    /**
     * Gets stored chats.
     */
    static getChatsData() {
        return {
            chats: this.getData()?.chats ?? [],
            actionsState: this.getData()?.chatActionsState,
        };
    }

    /**
     * Stores last used FAQs.
     * @param {object[]} faqs Last used FAQs.
     */
    static setLastFaqs(faqs) {
        const data = this.getData();
        if (data) {
            data.lastFaqs = faqs;
            localStorage.setItem('data', JSON.stringify(data));
        }
    }

    /**
     * Gets the last stored FAQs.
     */
    static getLastFaqs() {
        return this.getData()?.lastFaqs ?? [];
    }

}